module.exports = __webpack_public_path__ + "media/images/members/don_w_cruickshank-215ec7e7f8c7c1a7c3c417650624fdfb.jpg";